import {
  GET_MIXTURE_ENTRIES_REQUEST,
  GET_MIXTURE_ENTRIES_ERROR,
  GET_MIXTURE_ENTRIES_SUCCESS,
  CREATE_MIXTURE_ENTRIES_REQUEST,
  CREATE_MIXTURE_ENTRIES_ERROR,
  CREATE_MIXTURE_ENTRIES_SUCCESS,
  CREATE_ENTRY_REQUEST,
  CREATE_ENTRY_ERROR,
  CREATE_ENTRY_SUCCESS,
  UPDATE_ENTRY_OBJ,
  EDIT_ENTRY_SUCCESS
} from "../../actions/types";
import reducers from "../common"

const initialState = {};
export default (state = initialState, action) => {

  reducers.init(reducers);

  reducers.GET_ENTITY_REQUEST = GET_MIXTURE_ENTRIES_REQUEST;
  reducers.GET_ENTITY_ERROR = GET_MIXTURE_ENTRIES_ERROR;
  reducers.GET_ENTITY_SUCCESS = GET_MIXTURE_ENTRIES_SUCCESS;
  reducers.CREATE_ENTITIES_REQUEST = CREATE_MIXTURE_ENTRIES_REQUEST;
  reducers.CREATE_ENTITIES_ERROR = CREATE_MIXTURE_ENTRIES_ERROR;
  reducers.CREATE_ENTITIES_SUCCESS = CREATE_MIXTURE_ENTRIES_SUCCESS;
  reducers.entityName = "mixtureEntries";

  if (action.type === UPDATE_ENTRY_OBJ && action.payload.entryType === reducers.entityName) {
    const mixturesInState = action.payload.fullState.mixture.mixture
    const newMixture = mixturesInState ? mixturesInState[action.payload.entry.Mixture.ID] : null
    delete action.payload.entry.Pensum
    return {
      ...state,
      [action.payload.entryType]: {
        ...state[action.payload.entryType],
        [action.payload.entry.ID]: {
          ...state[action.payload.entryType][action.payload.entry.ID],
          ...action.payload.entry,
          Mixture: newMixture ? newMixture : state[action.payload.entryType][action.payload.entry.ID].Mixture
        }
      }
    }
  }
  if (action.type === EDIT_ENTRY_SUCCESS && action.entryType === "MixtureEntries") {
    const entryName = action.entryType.charAt(0).toLowerCase() + action.entryType.slice(1)
    return {
        ...state,
        [entryName]: {
          ...state[entryName],
          [action.payload.ID]: {
            ...state[entryName][action.payload.ID],
            ...action.payload
          }
        },
        isFetching: false,
        error: undefined
    }
  }
  if (action.type === CREATE_ENTRY_REQUEST && action.entryType === "MixtureEntries") {
    return {
      ...state,
      isFetching: false,
      error: undefined
    }
  }
  if (action.type === CREATE_ENTRY_SUCCESS && action.entryType === "MixtureEntries") {
    return {
      ...state,
      mixtureEntries: {
        ...state.mixtureEntries,
        [action.payload.ID]: {
          ...action.payload
        }
      },
      isFetching: false,
      error: undefined
    }
  }
  if (action.type === CREATE_ENTRY_ERROR && action.entryType === "MixtureEntries") {
    return {
      ...state,
      isFetching: false,
      error: `${action.error}`
    }
  }

  return reducers.entity(reducers)(state, action);
};
